module.exports = __webpack_public_path__ + "img/ri_skype-fill.592dd2b4.svg";